import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import ReactDOM from "react-dom";
import './assets/main.css';
import App from "./App";





ReactDOM.render(<App />, document.getElementById("root"));
